import { Divider } from '@mui/material'

export const SubMenuDivider = () => {
  return <Divider sx={{ my: 1 }} />
}
